module.exports = __webpack_public_path__ + "static/media/loader.d69bc159.svg";